// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__t+dHg","spinner":"LoadingSpinner_spinner__jd7HQ"};